import {
  Alert,
  Backdrop,
  Card,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  ListItem,
  Snackbar,
} from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppConfig from "appConfig";

function PSAViewPage() {
  const pageTitle = `Product Sampling`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [products, setProducts] = useState([]);
  const [samplings, setSamplings] = useState(0);
  const [feedbacks, setFeedbacks] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/psa/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            setProducts(result.data.data.products);
            setSamplings(result.data.data.sampled);
            setFeedbacks(result.data.data.feedbacks);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={2} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDBox>
                    <ListItem>
                      <MDBox
                        width="100%"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDBox>
                          <MDTypography variant="h6">
                            {campaign.title}
                          </MDTypography>
                          <MDTypography fontSize={12} color="text.secondary">
                            {campaign.account.name}
                          </MDTypography>
                        </MDBox>

                        <MDBox>
                          <img
                            src={`${AppConfig.api_media_url}${campaign.account.icon}`}
                            alt=""
                            width="18px"
                          />
                        </MDBox>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Card>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontSize={14} mb={2}>
                    Products
                  </MDTypography>
                  {products.map((prd) => (
                    <MDBox mb={2}>
                      <ListItem divider>
                        <MDBox
                          width="100%"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          pb={1}
                        >
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              fontWeight="regular"
                              fontSize={14}
                            >
                              {prd.title}
                            </MDTypography>
                            <MDTypography
                              fontSize={12}
                              fontWeight="light"
                              color="text.secondary"
                            >
                              {`${campaign.account.currency}${(
                                prd.price / 100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </MDTypography>
                          </MDBox>

                          <MDBox align="center">
                            <MDTypography
                              variant="h6"
                              fontWeight="regular"
                              fontSize={14}
                            >
                              Sample Quantity
                            </MDTypography>
                            <MDTypography fontSize={12} fontWeight="light">
                              {prd.sample_quantity}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </ListItem>
                    </MDBox>
                  ))}
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <Card>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          {samplings}
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontSize={13}
                          fontWeight="light"
                        >
                          {samplings === 1 ? "Customer" : "Customers"}
                          <br />
                          Sampled
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <Card>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          {feedbacks}
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontSize={13}
                          fontWeight="light"
                        >
                          {feedbacks === 1 ? "Feedback" : "Feedbacks"}
                          <br />
                          Submitted
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <MDBox>
                <MDButton
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<Icon>edit_note</Icon>}
                  onClick={() => {
                    navigate(
                      `/activations/product-sampling/record/sample/${ref}`,
                    );
                  }}
                >
                  Sample Customer
                </MDButton>
              </MDBox>
              {/* <MDBox mt={3}>
                <MDButton
                  variant="outlined"
                  color="primary"
                  fullWidth
                  endIcon={<Icon>add_location</Icon>}
                  onClick={() => {
                    navigate(`/activations/display-win/${ref}/retailers/`);
                  }}
                >
                  Contact Customer
                </MDButton>
              </MDBox> */}
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PSAViewPage;
